import React from "react";

const ImportexpoertIcon = (props) => {
  let height = props?.height ? props?.height : 20;
  let width = props?.width ? props?.width : 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 32 32"
      fill-rule="evenodd"
      class=""
    >
      <g>
        <path
          d="M20.519 14h6a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-6v1.898a1.5 1.5 0 0 1-2.488 1.129l-6.311-5.522a2 2 0 0 1 0-3.01l6.311-5.522a1.499 1.499 0 0 1 2.488 1.129zM25 24v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11.395c.531 0 1.039.211 1.415.586l5.604 5.604c.375.376.586.884.586 1.415V12h-2.483a3.5 3.5 0 0 0-5.803-2.532l-6.311 5.522a4 4 0 0 0 0 6.02l6.311 5.522A3.5 3.5 0 0 0 22.517 24z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
};

export default ImportexpoertIcon;
